"use client";
import {
  GridProps,
  Heading,
  ResponsiveValue,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/react";
import {Balancer} from "react-wrap-balancer";
import {useSectionHeadingVariant} from "@/theme/components/useSectionHeading";
import {TEXT_VARIANTS} from "@/theme/components/text";
import Card, {CardProps} from "./card";

type Props = {
  columns?: ResponsiveValue<number>;
  desc?: string;
  list: CardProps[];
  spacing?: GridProps["gridGap"];
  title?: string;
  hoverEffect?: boolean;
  hover?: Record<string, any>;
};

const CardsList = (props: Props) => {
  const {
    columns = {base: 1, sm: 2, md: 4},
    desc,
    list,
    spacing = {base: 8, md: 12, "2xl": 16},
    title,
    hoverEffect = false,
    hover,
  } = props;
  const headingVariant = useSectionHeadingVariant();

  return (
    <Stack spacing={8}>
      <Stack spacing={6}>
        {title && (
          <Heading as="h3" variant={headingVariant} textAlign={"center"}>
            {title}
          </Heading>
        )}
        <Balancer>
          {desc && (
            <Text variant={TEXT_VARIANTS.LABEL1} color={"text.100"} textAlign={"center"}>
              {desc}
            </Text>
          )}
        </Balancer>
      </Stack>
      <SimpleGrid columns={columns} spacing={spacing}>
        {list.map((item, index) => (
          <Card key={index} {...item} hoverEffect={hoverEffect} hover={hover} />
        ))}
      </SimpleGrid>
    </Stack>
  );
};

export default CardsList;
